// extracted by mini-css-extract-plugin
export default {"Faq":"Faq_Faq__rIfG6"};